import { action, makeAutoObservable } from "mobx";
import ElementModel from "../../model/ElementModel";
import { RootStore } from "../index";
import { ISectionMenuL1, ISectionMenuL2 } from "../../interface/ISection";
import { HelperCatalog } from "../../helper/HelperCatalog";

interface IBrand {
  id: number;
  ex_id: string;
  name: string;
}

export class PageCatalogStore {
  private rootStore: RootStore | undefined;

  pagination = {
    countPage: 1,
    countRow: 1,
    currentPage: 1,
  };

  urlFilter: string | undefined;
  originalUrlFilter: string | undefined; // Для хранения исходного фильтра до обработки

  orderModel: string = "";
  orderField: string = "id";
  orderBy: string = "DESC";

  arItems = [];
  productList = [];
  isEmptyResult: boolean = false;
  isLoading: boolean = false;

  public error: string = "";
  private section1: null | string = "";
  private section2: null | string = "";
  private title: string = "Каталог";

  openCatalog: boolean = false;

  // Новые свойства для отслеживания состояния меню
  openMenuSections: Set<string> = new Set(); // Хранит коды открытых секций L1
  selectedSectionL1: string | null = null; // Выбранная секция L1
  selectedSectionL2: string | null = null; // Выбранная секция L2

  constructor(rootStore?: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;

    // Восстанавливаем состояние меню из localStorage
    this.restoreMenuState();
  }

  onCurrentPage = (page: number) => {
    let baseUrl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname;
    let newUrl = baseUrl + "?page=" + page;
    // @ts-ignore
    window.history.pushState(null, null, newUrl);
    this.pagination.currentPage = page;
    this.reload();
  };

  init(
    code1: string | undefined,
    code2: string | undefined,
    filter: string | undefined,
    page: number = 1
  ) {

    this.urlFilter = filter;
    this.originalUrlFilter = filter; // Сохраняем исходный фильтр
    console.log("code1", code1);
    console.log("code2", code2);
    console.log("filter", filter);
    console.log("page", page);
    
    if (code1 === undefined) {
      this.section1 = null;
    } else {
      this.section1 = code1;
    }
    if (code2 === undefined) {
      this.section2 = null;
    } else {
      this.section2 = code2;
    }

    // Восстанавливаем состояние меню на основе URL
    this.setSelectedSections(code1 || null, code2 || null);

    this.rootStore?.componentFilterCatalogStore.init(filter);
    this.reload(true, page);
  }

  reload(init: boolean = false, page: number = 1) {

    this.arItems = []
    this.isEmptyResult = false; // Reset empty result state
    this.isLoading = true; // Set loading state
    if (init) {
      this.pagination.currentPage = 1;
    }
    if (init && page) {
      this.pagination.currentPage = page;
    }


    // this.setUrlPage();

    // обновляем список у фильтра
    this.rootStore?.componentFilterCatalogStore.setFilter();
    let token = localStorage.getItem("token");
    if (token && !ElementModel.q.token) {
      ElementModel.q.setBaseUrl();
      ElementModel.q.reload();
    }
    this.rootStore?.componentCatalogSectionStore.init(this.rootStore?.mainStore.getClientId());

    ElementModel.getCatalog(
      {
        json: {
          clientId: this.rootStore?.mainStore.getClientId(),
          limit: 32,
          filter: this.setFilter(),
          sort: this.setSort(),
        },
        page: this.pagination.currentPage,
      },
      this.setCatalog,
      this.setError
    );
  }

  reloadMain = () => {
    let clientId = this.rootStore?.mainStore.getClientId();
    this.pagination.currentPage = 1;
    // обновляем список у фильтра
    this.rootStore?.componentFilterCatalogStore.setFilter();
    ElementModel.getCatalog(
      {
        json: {
          clientId: clientId,
          limit: 32,
          filter: this.setFilter(),
          sort: this.setSort(),
        },
        page: this.pagination.currentPage,
      },
      this.setCatalogMain,
      this.setError
    );

    this.rootStore?.componentFilterCatalogStore.init(this.urlFilter);
  };

  getAllCatalogList = () => {
    let clientId = this.rootStore?.mainStore.getClientId();
    ElementModel.getAllCatalogList(
      {
        json: {
          clientId: clientId,
        },
      },
      this.setProductList,
      this.setError
    );
  };

  getBaseUrlCatalog() {
    let s = "/catalog/";
    if (this.section1 !== "undefined") {
      s += this.section1 + "/";
    }
    if (this.section2 !== "undefined") {
      s += this.section2 + "/";
    }
    return s;
  }

  setUrlPage() {
    let url = this.getBaseUrlCatalog();
    let sFilter = this.rootStore?.componentFilterCatalogStore.setFilterUrl();
    if (sFilter) {
      url += "filter/" + sFilter;
    }
    //ToDo task number 45215 from
    if (window.location.search.length) {
      let page = window.location.search;
      // @ts-ignore
      url += page;
    }
    // @ts-ignore
    window.history.pushState(null, null, url);
  }

  setFilter() {
    let filter = {};
    // @ts-ignore
    filter["props"] = {};
    filter = this.setFilterProps(filter);
    filter = this.SetSection(filter);
    return filter;
  }

  setFilterProps(filter: any) {
    const {
      arBrandChecked,
      arKindChecked,
      isNoveltyFilter,
      isSelloutFilter,
      isSaleFilter,
      isLoyaltyFilter,
    } =
      // @ts-ignore
      this.rootStore.componentFilterCatalogStore;

    if (arBrandChecked.length) {
      filter["props"]["brand"] = arBrandChecked;
    }
    if (arKindChecked.length) {
      filter["props"]["itemType"] = arKindChecked;
    }

    if (isNoveltyFilter) {
      filter["props"]["isNovelty"] = true;
    }
    if (isSelloutFilter) {
      filter["props"]["isSellout"] = true;
    }
    if (isSaleFilter) {
      filter["props"]["isSale"] = true;
    }
    if (isLoyaltyFilter) {
      filter["props"]["isIncludeLoyaltyProgram"] = true;
    }
    return filter;
  }

  @action
  setCatalog = (result: any) => {
    this.arItems = result.data.rows;
    this.pagination = result.data.pagination;
    // Check if results are empty
    this.isEmptyResult = result.data.rows && result.data.rows.length === 0;
    this.isLoading = false; // Reset loading state
    this.rootStore?.basePageStore
      .setBreadCrumbs(result.data.BreadCrumbs, "catalog")
      .setTitleInBreadCrumbs();
  };

  @action
  setCatalogMain = (result: any) => {
    this.arItems = result.data.rows;
    this.pagination = result.data.pagination;
    // Check if results are empty
    this.isEmptyResult = result.data.rows && result.data.rows.length === 0;
    this.isLoading = false; // Reset loading state
  };
  @action
  setProductList = (result: any) => {
    this.productList = result.data.rows;
  };

  @action
  setError = (error: any) => {
    this.isLoading = false; // Reset loading state on error
    if (
      error !== undefined &&
      error.response !== undefined &&
      error.response.data !== undefined &&
      error.response.data.message !== undefined
    ) {
      this.error = String(error.response.data.message);
    }
  };

  public SetSection(filter: {} = {}) {
    if (this.section1 === "" && this.section2 === "") {
      return filter;
    }
    if (this.section1 !== "undefined" || this.section2 !== "undefined") {
      // @ts-ignore
      filter["sectionIds"] = [];
      if (this.section1 !== "undefined") {
        // @ts-ignore
        filter["sectionIds"].push(this.section1);
      }
      if (this.section2 !== "undefined") {
        // @ts-ignore
        filter["sectionIds"].push(this.section2);
      }
    }
    return filter;
  }

  @action
  setPageCatalog = () => {
    this.rootStore?.basePageStore
      .setBreadCrumbs([], "catalog")
      .setTitleInBreadCrumbs();
    this.rootStore?.componentFilterCatalogStore.resetShowFilter();
    this.setOpenCatalog()
  };

  @action
  setOpenCatalog = () => {
    this.openCatalog = !this.openCatalog
  };

  @action
  public setPageCatalogL1 = (el1: ISectionMenuL1) => {
    this.rootStore?.componentFilterCatalogStore.resetShowFilter();
    this.section1 = el1.code;
    this.rootStore?.basePageStore
      .setBreadCrumbs(
        [
          {
            url: HelperCatalog.getUrlList(el1, null),
            name: el1.name,
          },
        ],
        "catalog"
      )
      .setTitleInBreadCrumbs();
    this.title = el1.name;
    this.rootStore?.basePageStore.setTitleInBreadCrumbs();

    // Сохраняем состояние выбранной секции
    this.setSelectedSections(el1.code, null);

    this.reload(true);
  };

  @action
  public setPageCatalogL2 = (
    el1: ISectionMenuL1,
    el2: ISectionMenuL2 | null
  ) => {

    this.rootStore?.componentFilterCatalogStore.resetShowFilter();
    this.section1 = el1.code;
    if (el2 === null) {
      this.title = el1.name;
      this.rootStore?.basePageStore
        .setBreadCrumbs(
          [
            {
              url: HelperCatalog.getUrlList(el1, el2),
              name: el1.name,
            },
          ],
          "catalog"
        )
        .setTitleInBreadCrumbs();

      // Сохраняем состояние выбранной секции L1
      this.setSelectedSections(el1.code, null);
    } else {
      this.title = el2.name;
      this.rootStore?.basePageStore
        .setBreadCrumbs(
          [
            { url: HelperCatalog.getUrlList(el1, null), name: el1.name },
            { url: HelperCatalog.getUrlList(el1, el2), name: el2.name },
          ],
          "catalog"
        )
        .setTitleInBreadCrumbs();

      // Сохраняем состояние выбранных секций L1 и L2
      this.setSelectedSections(el1.code, el2.code);
    }
    this.reload(true);
  };

  private setSort() {
    return {
      orderModel: this.orderModel,
      orderField: this.orderField,
      orderBy: this.orderBy,
    };
  }

  @action clearSort = () => {
    this.orderField = "id";
    this.orderModel = "";
    this.orderBy = "DESC";
    this.reload(true);
  };

  @action
  public setSortParams = (orderField: string) => {
    if (this.orderField === orderField && this.orderBy === "ASC") {
      this.clearSort();
      return false;
    }

    if (this.orderField === orderField) {
      this.orderBy = this.orderBy === "ASC" ? "DESC" : "ASC";
    } else {
      this.orderBy = "DESC";
    }
    if (orderField === "price") {
      this.orderModel = "prices";
    } else {
      this.orderModel = "";
    }
    this.orderField = orderField;
    this.reload(true);
  };

  // Методы для управления состоянием меню
  @action
  toggleMenuSection = (sectionCode: string) => {
    if (this.openMenuSections.has(sectionCode)) {
      this.openMenuSections.delete(sectionCode);
    } else {
      this.openMenuSections.add(sectionCode);
    }
    this.saveMenuState();
  };

  @action
  setMenuSectionOpen = (sectionCode: string, isOpen: boolean) => {
    if (isOpen) {
      this.openMenuSections.add(sectionCode);
    } else {
      this.openMenuSections.delete(sectionCode);
    }
    this.saveMenuState();
  };

  @action
  isMenuSectionOpen = (sectionCode: string): boolean => {
    return this.openMenuSections.has(sectionCode);
  };

  @action
  setSelectedSections = (sectionL1: string | null, sectionL2: string | null = null) => {
    this.selectedSectionL1 = sectionL1;
    this.selectedSectionL2 = sectionL2;

    // Автоматически открываем родительскую секцию, если выбрана дочерняя
    if (sectionL1) {
      this.openMenuSections.add(sectionL1);
    }

    this.saveMenuState();
  };

  @action
  isSectionSelected = (sectionCode: string, isL2: boolean = false): boolean => {
    if (isL2) {
      return this.selectedSectionL2 === sectionCode;
    }
    return this.selectedSectionL1 === sectionCode;
  };

  @action
  clearMenuState = () => {
    this.openMenuSections.clear();
    this.selectedSectionL1 = null;
    this.selectedSectionL2 = null;
    this.saveMenuState();
  };

  // Методы для работы с localStorage
  private saveMenuState = () => {
    try {
      const menuState = {
        openMenuSections: Array.from(this.openMenuSections),
        selectedSectionL1: this.selectedSectionL1,
        selectedSectionL2: this.selectedSectionL2
      };
      localStorage.setItem('catalogMenuState', JSON.stringify(menuState));
    } catch (error) {
      console.warn('Failed to save menu state to localStorage:', error);
    }
  };

  private restoreMenuState = () => {
    try {
      const savedState = localStorage.getItem('catalogMenuState');
      if (savedState) {
        const menuState = JSON.parse(savedState);
        this.openMenuSections = new Set(menuState.openMenuSections || []);
        this.selectedSectionL1 = menuState.selectedSectionL1 || null;
        this.selectedSectionL2 = menuState.selectedSectionL2 || null;
      }
    } catch (error) {
      console.warn('Failed to restore menu state from localStorage:', error);
    }
  };

  /**
   * Обрабатывает URL фильтр для конвертации UUID брендов в числовые ID
   * @param urlFilter - исходный URL фильтр
   * @param brandArray - массив брендов с полями id и ex_id
   * @returns обработанный URL фильтр
   */
  private processBrandFilter(urlFilter: string, brandArray: IBrand[]): string {
    // Проверяем, содержит ли фильтр brand-in- с UUID
    const brandInRegex = /brand-in-([a-f0-9-]{36})/g;
    const matches = urlFilter.match(brandInRegex);
    
    if (!matches || !brandArray || brandArray.length === 0) {
      return urlFilter;
    }

    let processedFilter = urlFilter;
    
    matches.forEach(match => {
      // Извлекаем UUID из match (brand-in-UUID)
      const uuid = match.replace('brand-in-', '');
      
      // Проверяем, является ли это UUID (36 символов с дефисами)
      const uuidRegex = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
      
      if (uuidRegex.test(uuid)) {
        // Ищем бренд с соответствующим ex_id
        const brand = brandArray.find(b => b.ex_id === uuid);
        
        if (brand && brand.id) {
          // Заменяем UUID на числовой ID
          const newBrandFilter = `brand-in-${brand.id}`;
          processedFilter = processedFilter.replace(match, newBrandFilter);
        }
      }
    });
    
    return processedFilter;
  }

  /**
   * Обрабатывает URL фильтр после загрузки брендов
   * Этот метод должен вызываться после того, как бренды загружены в componentFilterCatalogStore
   */
  @action
  processUrlFilterAfterBrandsLoaded = () => {
    // Проверяем, не обрабатывали ли мы уже этот фильтр
    if (this.urlFilter === this.originalUrlFilter && this.originalUrlFilter && this.rootStore?.componentFilterCatalogStore.arBrand) {
      const brandArray: IBrand[] = this.rootStore.componentFilterCatalogStore.arBrand;
      const processedFilter = this.processBrandFilter(this.originalUrlFilter, brandArray);
      
      // Если фильтр изменился, нужно перезагрузить данные
      if (processedFilter !== this.originalUrlFilter) {
        this.urlFilter = processedFilter;
        // Переинициализируем ComFilterCatalogStore с новым фильтром
        this.rootStore?.componentFilterCatalogStore.init(processedFilter);
        this.reload(true);
      }
    }
  }
}
